import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import {
  ActiveRides,
  AllDriver,
  ForgotPassword,
  Home,
  IncomePage,
  OutstandingBalance,
  RideHistory,
  SignIn,
  RefundRequest,
  RideHistoryDetail,
} from "../pages";
import InstantRequest from "../pages/InstantRequest/InstantRequest";
import PriceSurge from "../pages/PriceSurge/PriceSurge";
import PrivateRoute from "./PrivateRoute";
import RedirectIfLoggedIn from "./RedirectIfLoggedIn";
import DocumentVerification from "../pages/DocumentVerification/DocumentVerification";

function Navigation() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route
            path="/signin"
            element={<RedirectIfLoggedIn element={SignIn} redirectTo="/home" />}
          />
          <Route
            path="/"
            element={<RedirectIfLoggedIn element={SignIn} redirectTo="/home" />}
          />
          <Route
            path="/home"
            element={<PrivateRoute element={Home} redirectTo="/signin" />}
          />
          <Route
            path="/forgotPassword"
            element={
              <PrivateRoute element={ForgotPassword} redirectTo="/signin" />
            }
          />
          <Route
            path="/rideHistory"
            element={
              <PrivateRoute element={RideHistory} redirectTo="/signin" />
            }
          />
          <Route
            path="/rideHistory/:id"
            element={
              <PrivateRoute element={RideHistoryDetail} redirectTo="/signin" />
            }
          />
          <Route
            path="/income"
            element={<PrivateRoute element={IncomePage} redirectTo="/signin" />}
          />
          <Route
            path="/instantRequest"
            element={
              <PrivateRoute element={InstantRequest} redirectTo="/signin" />
            }
          />
          {/* <Route
            path="/outstandingBalance"
            element={
              <PrivateRoute element={OutstandingBalance} redirectTo="/signin" />
            }
          /> */}
          <Route
            path="/allDriver"
            element={<PrivateRoute element={AllDriver} redirectTo="/signin" />}
          />
          <Route
            path="/priceSurge"
            element={<PrivateRoute element={PriceSurge} redirectTo="/signin" />}
          />
          <Route
            path="/activeRides"
            element={
              <PrivateRoute element={ActiveRides} redirectTo="/signin" />
            }
          />
          <Route
            path="/refundRequest"
            element={
              <PrivateRoute element={RefundRequest} redirectTo="/signin" />
            }
          />
          <Route
            path="/documentVerification"
            element={
              <PrivateRoute
                element={DocumentVerification}
                redirectTo="/signin"
              />
            }
          />
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </>
  );
}

export default Navigation;

